import SignUpPage from './sign-up-page'

export default SignUpPage